import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import CodeNotExist from '../../components/popups/reward/CodeNotExist'
import {
  DEFAULT_CONTAINER_STATE,
  QR_CODE_PROCESS_STEP,
  REWARD_POINTS_PROCESS_STEP
} from '../../constants/containerStates'
import { REWARDS_PROFILE_DISPATCH } from '../../store/reducers/rewards/rewards'

import CameraBlocked from '../../components/popups/qrCode/CameraBlocked'
import ReceiveRewardByQrCode from '../../components/popups/qrCode/ReceiveRewardByQrCode'
import { SIGNUP_URL } from '../../constants/navigation'
import { extractCodeOrInputText } from '../../util/string.helpers'
import { validRewardCodeRule } from '../../util/validation/validation.helpers'
import RewardContainer from './RewardContainer'

const RewardContainerQrCode = (props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { changeRewardsState } = props
  const [popupState, setPopupState] = useState(DEFAULT_CONTAINER_STATE.NONE)

  const handleQrCodeClick = () => {
    setPopupState(QR_CODE_PROCESS_STEP.SCAN_CODE)
  }

  const handleCancelQrCode = () => {
    setPopupState(DEFAULT_CONTAINER_STATE.NONE)
  }

  const handleQrCodeError = () => {
    setPopupState(QR_CODE_PROCESS_STEP.CAMERA_BLOCKED)
  }

  const handleQrCodeScan = (text) => {
    if (text) {
      const rewardCode = extractCodeOrInputText(text)
      if (rewardCode) {
        const validRewardCode = validRewardCodeRule(rewardCode)
        if (validRewardCode) {
          changeRewardsState(
            REWARDS_PROFILE_DISPATCH.REWARD_CODE,
            validRewardCode
          )
          navigate(SIGNUP_URL, { replace: true })
        } else {
          setPopupState(REWARD_POINTS_PROCESS_STEP.WRONG_REWARD_CODE)
        }
      } else {
        setPopupState(REWARD_POINTS_PROCESS_STEP.WRONG_REWARD_CODE)
      }
    }
  }

  const handleOnTryAgain = () => {
    changeRewardsState(REWARDS_PROFILE_DISPATCH.REWARD_CODE, '')
    setPopupState(QR_CODE_PROCESS_STEP.SCAN_CODE)
  }

  const renderPopup = () => {
    switch (popupState) {
      case QR_CODE_PROCESS_STEP.SCAN_CODE:
        return (
          <ReceiveRewardByQrCode
            onCancel={handleCancelQrCode}
            onError={handleQrCodeError}
            onScan={handleQrCodeScan}
            t={t}
          />
        )
      case QR_CODE_PROCESS_STEP.CAMERA_BLOCKED:
        return <CameraBlocked onCancel={handleCancelQrCode} t={t} />
      case REWARD_POINTS_PROCESS_STEP.WRONG_REWARD_CODE:
        return <CodeNotExist onSubmit={handleOnTryAgain} t={t} />
      default:
        break
    }
  }

  return (
    <>
      <RewardContainer
        onQrCodeClick={handleQrCodeClick}
        qrCodeEnabled
        {...props}
      />
      {renderPopup()}
    </>
  )
}

export default RewardContainerQrCode
